import { FC } from "react";
import CustomTab, { TabData } from "../../components/commons/tabs/CustomTab";
import EditProfile from "../../components/profile/EditProfile";
import OutlookIntegration from "../../components/integrations/OutlookIntegration";
import { useCurrentUser } from "../../components/commons/currentuser/CurrentUserHook";
import { ROLES } from "../../_helpers/constants";

const ProfileTab: FC = () => {
  const { user } = useCurrentUser();

  const tabList: TabData[] = [
    { label: 'Perfil de usuario', component: <EditProfile /> },
    ...(user.role !== ROLES.admin ? [{ label: 'Integraciones', component: <OutlookIntegration /> }] : []),
  ]

  return (<CustomTab tabs={tabList} />);
}

export default ProfileTab